/**
 * Actions that require step-up reauth (a fresh PIN confirmation) before
 * they can be executed. Each protected endpoint on the backend declares
 * its action via `@ReauthRequired(...)`; the FE mints an action-scoped
 * token through `POST /auth/confirm-pin` and passes it in the
 * `X-Reauth-Token` header.
 *
 * Tokens are single-use, TTL-bounded (5 min), and scoped — a token
 * issued for `WITHDRAW` will 401 if replayed against `END_LIVE`.
 */
export const REAUTH_ACTIONS = {
  END_LIVE: 'END_LIVE',
  CANCEL_EVENT: 'CANCEL_EVENT',
  WITHDRAW: 'WITHDRAW',
  FUND_ESCROW: 'FUND_ESCROW',
} as const;

export type ReauthAction = (typeof REAUTH_ACTIONS)[keyof typeof REAUTH_ACTIONS];
